import { render, staticRenderFns } from "./AppointmentBubble.vue?vue&type=template&id=167fceec&scoped=true"
import script from "./AppointmentBubble.vue?vue&type=script&lang=js"
export * from "./AppointmentBubble.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBubble.vue?vue&type=style&index=0&id=167fceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fceec",
  null
  
)

export default component.exports